import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "/liquicent-logo.png";

const FooterNew = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    platform: [
      { name: 'How It Works', path: '/#how-it-works' },
      { name: 'Workflow Simulator', path: '/workflow-simulator' },
      { name: 'Platform Economics', path: '/platform-economics' },
      { name: 'Pricing', path: '/pricing' },
    ],
    workflows: [
      { name: 'PR Governance', path: '/workflows/pr-governance' },
      { name: 'Security & Compliance', path: '/workflows/security-compliance' },
      { name: 'Customer Support', path: '/workflows/customer-support' },
      { name: 'Sales Deal Desk', path: '/workflows/sales-deal-desk' },
      { name: 'Vendor Onboarding', path: '/workflows/vendor-onboarding' },
    ],
    developers: [
      { name: 'Documentation', path: '/developers' },
      { name: 'API Reference', path: '/developers/apis' },
      { name: 'Agent SDK', path: '/developers/agent-sdk' },
      { name: 'Publish Agent', path: '/developers/publish-agent' },
    ],
    research: [
      { name: 'Unified Transaction Graph', path: '/research/unified-transaction-graph' },
      { name: 'DecisionTrace', path: '/research/decisiontrace' },
      { name: 'WorkRank', path: '/research/workrank' },
      { name: 'SocioTRank', path: '/research/sociotrank' },
    ],
    company: [
      { name: 'About', path: '/about' },
      { name: 'Blog', path: '/blog' },
      { name: 'Careers', path: '/careers' },
      { name: 'Contact', path: '/contact' },
    ],
    legal: [
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Security', path: '/security' },
    ],
  };

  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Liquicent" 
                className="w-8 h-8 object-contain"
              />
              <span className="text-xl font-semibold tracking-tight">Liquicent</span>
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              Coordination infrastructure for the autonomous enterprise.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-semibold text-sm mb-4">Platform</h4>
            <ul className="space-y-3">
              {footerLinks.platform.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#94A3B8] hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Workflows */}
          <div>
            <h4 className="font-semibold text-sm mb-4">Workflows</h4>
            <ul className="space-y-3">
              {footerLinks.workflows.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#94A3B8] hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Developers */}
          <div>
            <h4 className="font-semibold text-sm mb-4">Developers</h4>
            <ul className="space-y-3">
              {footerLinks.developers.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#94A3B8] hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Research */}
          <div>
            <h4 className="font-semibold text-sm mb-4">Research</h4>
            <ul className="space-y-3">
              {footerLinks.research.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-[#94A3B8] hover:text-white text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1E293B]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#64748B] text-sm">
              &copy; {currentYear} Liquicent. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {footerLinks.legal.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-[#64748B] hover:text-white text-sm transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
